export default {
  country_locale: 'nl-BE',
  wia_title: 'Laten we beginnen met het produkt:',
  wia_need_help: 'Je hebt hulp nodig met',
  wia_model_name: 'Het produkt heet',
  wia_back: '< wijzig',
  wia_confirm: 'Doorgaan',
  wia_issue_title: 'Wat is het probleem?',
  wia_issue_concern: 'Welk probleem doet zich voor?',
  wia_issue_specific: 'Verdere details',
  wia_possible_solution: 'Mogelijke oplossingen',
  wia_solved_issue: 'Is het probleem opgelost?',
  wia_closed: 'Sluiten X',
  wia_feedback_ok: ' Ja!',
  wia_find_another_solution: 'Probeer een andere oplossing.',
  wia_feedback_title: 'We zijn blij dat het probleem is opgelost!',
  wia_feedback_text1: 'Bezoek onze shop en ontdek de speciale aanbiedingen voor jou',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Ontdek onze garantieplannen',
  wia_smile_down_popup_title: 'Heb je meer hulp nodig?',
  wia_smile_down_popup_text1: 'Ga naar de tweede stap',
  wia_smile_down_popup_or_text: 'of',
  wia_smile_down_popup_text2: 'Maak een afspraak',
  wia_need_more_help: 'Heb je meer hulp nodig?',
  wia_optional_label: '(Optioneel)',
  wia_no_solution: 'Het is ons niet gelukt om een simpele oplossing te vinden voor het probleem maar maak je geen zorgen, we zijn er om te helpen. Klik hier om verdere hulp te krijgen.',
  wia_all_solution: 'Alle storingen per categorie',
  wia_all_categories: 'Alle categorieën',
  wia_seo_l1_issue: 'Alle storingen per categorie',
  wia_seo_wp_country_name: 'Belux',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'BE',
  wia_seo_wp_meta_title: 'Problemen en oplossingen',
  wia_seo_bk_meta_title: 'Problemen en oplossingen',
  wia_seo_hp_meta_title: 'Problemen en oplossingen',
  wia_seo_id_meta_title: 'Problemen en oplossingen',
  wia_seo_wp_meta_description: 'Los de problemen van jouw apparaten op in een paar klikken met de online technische assistentie van European Appliances Belgium NV',
  wia_seo_bk_meta_description: 'Los de problemen van jouw apparaten op in een paar klikken met de online technische assistentie van Bauknecht Belux',
  wia_seo_hp_meta_description: 'Los de problemen van jouw apparaten op in een paar klikken met de online technische assistentie van Hotpoint Belux',
  wia_seo_id_meta_description: 'Los de problemen van jouw apparaten op in een paar klikken met de online technische assistentie van Indesit Belux',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
